import { TextField, ThemeProvider, createTheme } from "@mui/material";
import React, { useEffect, useState, useMemo, useRef } from "react";
// import Navbar from "./Nav_Side/Navbar";
// import Sidebar from "./Nav_Side/Sidebar";
// import altruist from "../../assets/images/altruist.jpg";
import axios from "axios";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import FilterTable from "../Filter/FilterTable";
import { common_axios } from "../../../App"; 
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import ReactTable from "../Reacttable/UserManagement/ReactTable";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import Swal from "sweetalert2";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
const NumberList = ({ resetValue }) => {
  const customId1 = "custom-id-yess";

  //.........useState..................//
  const [phoneNumber, setPhoneNumber] = useState();
  const [phoneNumber1, setPhoneNumber1] = useState(phoneNumber);
  const [error, seterror] = useState(false);
  const [data, setData] = useState([]);
  // console.log("data//", data);
  // console.log("nummmbbeerr", phoneNumber);
  const [userid, setUserId] = useState("");

  const [open, setOpen] = useState();
  const [hide, setHide] = useState(true);
  const [data1, setData1] = useState([]);
  const [userEditState, setUserEditState] = React.useState([]);
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [phoneNumber2, setPhoneNumber2] = useState(phoneNumber);
  const [error1, seterror1] = useState(false);
    const [viewUsername, setViewUserName] = useState([]);

  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [accountIdSkelton, setAccountIdSkelton] = useState(false);
  // ...................................Theme Provider....................................//
  // console.log("phoneNumber1------", phoneNumber1);
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const handlechangenumber = (e) => {
    // console.log("phonenumber", e.target.value);
    var target = e.target.value;
    var length = target.length;
    //  console.log("targetlength",length)
    // let addharVal = target.value.replace(/\s/g, "");
    if (length > 7) {
      target = target.slice(0, 8);
      target = target.replace(/[^\dA-Z]/g, "");
      // console.log("lengthhhhh", target);
      seterror(false);
    } else {
      seterror(true);
    }
    setPhoneNumber1(target);
    // target.value = target.value
    //   .replace(/[^\dA-Z]/g, "")
    //   .replace(/(.{4})/g, "$1 ")
    //   .trim();
    // target.selectionEnd = position +=
    //   target.value.charAt(position - 1) === " " &&
    //   target.value.charAt(length - 1) === " " &&
    //   length !== target.value.length
    //     ? 1
    //     : 0;
    // console.log("target", target.value.replace(/\s/g, ""));
  };
  const handlechangenumber1 = (e) => {
    console.log("phonenumber", e.target.value);
    var target = e.target.value;
    var length = target.length;
    //  console.log("targetlength",length)
    // let addharVal = target.value.replace(/\s/g, "");
    if (length > 9) {
      target = target.slice(0, 10);
      target = target.replace(/[^\dA-Z]/g, "");
      // console.log("lengthhhhh", target);
      seterror1(false);
    } else {
      seterror1(true);
    }
    setPhoneNumber2(target);
    // target.value = target.value
    //   .replace(/[^\dA-Z]/g, "")
    //   .replace(/(.{4})/g, "$1 ")
    //   .trim();
    // target.selectionEnd = position +=
    //   target.value.charAt(position - 1) === " " &&
    //   target.value.charAt(length - 1) === " " &&
    //   length !== target.value.length
    //     ? 1
    //     : 0;
    // console.log("target", target.value.replace(/\s/g, ""));
  };
  // .....................................Formik............................................//

  const initialValues = {
    msisdn: "",
  };
  const [details, setdetails] = useState({
    msisdn1: "",
  });

  const validationSchema = yup.object({
    msisdn: yup
  .string()
       .min(8, "Minimum length of a mobile number is 8 digits")
       .max(8, "Maximum length of mobile number is 8 digits")
      // .required("Required"),
      // .required("Required"),
      .nullable(),
    msisdn1: yup
  .string()
       .min(8, "Minimum length of a mobile number is 8 digits")
       .max(8, "Maximum length of mobile number is 8 digits")
      // .required("Required"),
      // .required("Required"),
      .nullable(),
  });

  const validationSchema1 = yup.object({
    msisdn1: yup
  .string()
       .min(8, "Minimum length of a mobile number is 8 digits")
       .max(8, "Maximum length of mobile number is 8 digits")
      // .required("Required"),
      // .required("Required"),
      .nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      seterror1(false);
      SearchPost(values);
    },
  });
  const [checkModal, setCheckModal] = useState("null");
  // console.log("checkmodal-----", checkModal);
  const formik1 = useFormik({
    initialValues: details,
    validateOnChange: false,
    enableReinitialize: true,
    // validationSchema: validationSchema1,

    onSubmit: (values) => {
      approveUserApi(values);
    },
  });
  const Reset = () => {
    setPhoneNumber2("");
  };

  // ---------------------------Account id---------------------------------------------------------------------
  async function AccountId() {
    // console.log("first");
    setAccountIdSkelton(true);
    try {
      // setHideSkeleton1(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`,
      
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
        setAccountIdSkelton(false);

        // setAccountIdValue(result.data.accountId);
      } else {
        // setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setAccountIdSkelton(false);
      }
    } catch (error) {
      setAccountIdSkelton(false);
      // setOpen(false);
      // setHideSkeleton1(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      //  });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // ----------------------------------------------------------------------------------------------------------
  // .............................Search API.............................................//
  const [Search, setSearch] = useState("");
  async function SearchPost(values) {

    try {
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/whitelist/v2/search/msisdn`,
        {
          whiteListReq: {
            msisdn: "222"+ formik.values.msisdn,
          },
         
        }
      );

      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        // setTableLoader(false);
        setOpen(false);
        // formik.handleReset();
        setHide(false);
        setPhoneNumber2("");
        setModifiedState(false);
     
        await setData([result.data.whiteListingResponse]);
        await setData1([result.data.whiteListingResponse]);
      
      } else {
        // setTableLoader(false);
        setData([]);
        setOpen(false);
    
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
       
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
     
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  async function UpdateGet(values) {
    // setTableLoader(true);
    // alert("123");
    try {
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/whitelist/v2/search/msisdn`,

      
        {
          whiteListReq: {
            msisdn:"222"+ phoneNumber1,
          },
        
        }
      );

      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        // setTableLoader(false);
        setOpen(false);
        formik.handleReset();
        setHide(false);
        setPhoneNumber2("");
     
        await setData([result.data.whiteListingResponse]);
        await setData1([result.data.whiteListingResponse]);
      } else {
        setData([])
        // setTableLoader(false);
        setOpen(false);
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  // const [byDeafultSelectedId, setByDefaultSelectedId] = useState([]);
  const [byDeafultDeleteId, setByDefaultDeleteId] = useState([]);
  const [deleteIdChange, setDeleteIdChange] = useState([]);
  // console.log("de--", userEditState);
  const approveUserModal = async (cell) => {
    // console.log("cell--", cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    // await setByDefaultSelectedId(cell.row.original.user);
    let temp = [];
    if (cell.row.original.allFlag == false) {
      await setUserEditState(cell.row.original.user);
    } else {
      temp.push({
        userId: "all",
        userName: "All",
      });
      await setUserEditState(temp);
    }
    setUserId(cell.row.original.id);
    setPhoneNumber(cell.row.original.msisdn);
    // setPhoneNumber1(cell.row.original.msisdn);
    setPhoneNumber1(cell.row.original.msisdn.slice(3));

    // console.log("phone-----", selectedUserDetailApprove);
    // setNumber(cell.row.original.msisdn);
    await setdetails({ msisdn1: cell.row.original.msisdn });
    await modelButtonApprove.current.click();
  };
  const [deleteData, setDeleteData] = useState("");
  const rejectUserModal = async (cell) => {

    setDeleteData(cell.row.original.msisdn);
    await setSelectedUserDetail(cell.row.original);
    await setByDefaultDeleteId(cell.row.original.user);
    await setDeleteIdChange(cell.row.original.user);
    let temp = [];
    if (cell.row.original.user.length > 0) {
      await setViewUserName(cell.row.original.user);
    } else {
      temp.push({
        userId: "all",
        userName: "All",
      });
      await setViewUserName(temp);
    }
    await modelButtonReject.current.click();
  };
  // console.log("deleteData-----", selectedUserDetail);
  const rejectUserApi = async (selectedUserDetail) => {
    let ids = deleteIdChange?.map((e) => e.dndId);
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/whitelist/v2/remove/msisdn`,
        {
          whiteListReq:{
            msisdn:selectedUserDetail.msisdn,
          }
      }
      );
      if (res.data.statusDescription.statusCode == 200) {
        // setData([]);
        setOpen(false);
        UpdateGet([])
        formik.handleReset();
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Mobile number deleted successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        setData([]);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // console.log("values-----", formik.values.msisdn);

  // const approveUserApi = async (values) => {
  //   let updateId = userEditState?.map((e) => e?.userId);
  //   if (error == false) {
  //     //    const butt = document.getElementById("getcancel");
  //     // butt.click();
  //     try {
  //       setOpen(true);
  //       const res = await common_axios.post(
  //         `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/whitelist/msisdn/update`,

  //         // `http://192.168.167.66:5002/v1/update/DND/msisdn`,
  //         {
  //           // id: userid,
  //           // // msisdn: number,
  //           // msisdn: phoneNumber1,

  //           whiteListReq: {
  //             oldMsisdn: selectedUserDetailApprove?.msisdn,
  //             //  modifiedBy:"demo",
  //             modifiedBy: localStorage.getItem("usernamedisplayed"),

  //             msisdn:"222"+ phoneNumber1,
  //             uid: updateId?.includes("all") ? null : updateId,
  //             allFlag: updateId?.includes("all") ? true : false,
  //           },
  //         }
  //       );
  //       console.log("update res----=", res);

  //       if (res.data.statusDescription.statusCode == 200) {
  //         // setCheckModal("modal")
  //         // console.log("dsghv",)
  //         const butt = document.getElementById("getcancel");
  //         butt.click();
  //         // formik.setFieldValue("msisdn",phoneNumber1)
  //         UpdateGet();
  //         setModifiedState(true);
  //         //  SearchPost1(values);
  //         // SearchPost()
  //         setOpen(false);
  //         // await toast.success("Mobile number updated successfully", {
  //         //   theme: "colored",
  //         // });
  //         Swal.fire({
  //           icon: "success",
  //           //  title: "Oops...",
  //           text: "Mobile number updated successfully",
  //           // footer: '<a href="">Why do I have this issue?</a>'
  //         });
  //         // SearchPost();
  //       }
  //       // else if (result.data.statusDescription.statusCode == 202) {
  //       //   toast.error("Mobile number already exists !!", {
  //       //     theme: "colored",
  //       //   });

  //       //   setOpen(false);
  //       // }
  //       else if (res.data.statusDescription.statusCode == 202) {
  //         const butt = document.getElementById("getcancel");
  //         butt.click();
  //         // toast.error("Mobile number is already exist!");
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: "Mobile number is already exist!",
  //           // footer: '<a href="">Why do I have this issue?</a>'
  //         });
  //         setOpen(false);
  //       } else {
  //         const butt = document.getElementById("getcancel");
  //         butt.click();
  //         setOpen(false);
  //         // await toast.error(res.data.statusDescription.statusdescription, {
  //         //   toastId: customId1,
  //         //   theme: "colored",
  //         // });
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: res.data.statusDescription.statusdescription,
  //           // footer: '<a href="">Why do I have this issue?</a>'
  //         });
  //       }
  //     } catch (error) {
  //       console.log(error);
  //       const butt = document.getElementById("getcancel");
  //       butt.click();
  //       setOpen(false);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Please Check Your Network",
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   }
  // };

  const approveUserApi = async (values) => {
    // let updateId = userEditState?.map((e) => e?.userId);

    // console.log("values-----", updateId);

    let userIds = [];
    for (let i = 0; i < userEditState.length; i++) {
      if (userEditState[i].userId != "all") {
        userIds[i] = userEditState[i].userId;
      }
    }

    if (error == false) {
      //    const butt = document.getElementById("getcancel");
      // butt.click();
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/whitelist/v2/update/msisdn`,

          // `http://192.168.167.66:5002/v1/update/DND/msisdn`,
          {
            // id: userid,
            // // msisdn: number,
            // msisdn: phoneNumber1,

            whiteListReq: {
              oldMsisdn: selectedUserDetailApprove?.msisdn,
              //  modifiedBy:"demo",
              modifiedBy: localStorage.getItem("usernamedisplayed"),

              msisdn:"222"+ phoneNumber1,
              // uid: updateId?.includes("all") ? null : updateId,
              // allFlag: updateId?.includes("all") ? true : false,

              uid:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
                ? userIds?.length > 0
                  ? userIds
                  : null
                : [JSON.parse(localStorage.getItem("items")).uid],
            // allFlag: false,
            // allFlag: userIds.includes("all") ? true : false,
             flag: userIds?.length > 0 ? false : true , 
            },
          }
        );
        // console.log("update res----=", res);

        if (res.data.statusDescription.statusCode == 200) {
          // setCheckModal("modal")
          // console.log("dsghv",)
          const butt = document.getElementById("getcancel");
          butt.click();
          // formik.setFieldValue("msisdn",phoneNumber1)
          UpdateGet();
          setModifiedState(true);
          //  SearchPost1(values);
          // SearchPost()
          setOpen(false);
          // await toast.success("Mobile number updated successfully", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            //  title: "Oops...",
            text: "Mobile number updated successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // SearchPost();
        }
        // else if (result.data.statusDescription.statusCode == 202) {
        //   toast.error("Mobile number already exists !!", {
        //     theme: "colored",
        //   });

        //   setOpen(false);
        // }
        else if (res.data.statusDescription.statusCode == 202) {
          const butt = document.getElementById("getcancel");
          butt.click();
          // toast.error("Mobile number is already exist!");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Mobile number is already exist!",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setOpen(false);
        } else {
          const butt = document.getElementById("getcancel");
          butt.click();
          setOpen(false);
          // await toast.error(res.data.statusDescription.statusdescription, {
          //   toastId: customId1,
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        // console.log(error);
        const butt = document.getElementById("getcancel");
        butt.click();
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };






  const [modifiedState, setModifiedState] = useState(false);

  const columns = useMemo(
    () =>
      modifiedState == false
        ? [
          {
            Header: "ID",
            Footer: "ID",
            accessor: "id",
            Cell: (cell ) => (
             <>{cell.row.index +1}</>
            ),
          },

            {
              Header: "Mobile Number",
              Footer: "Mobile Number",
              accessor: "msisdn",
            },
            {
              Header: "Created By",
              Footer: "Id",
              accessor: "createdBy", // accessor is the "key" in the data
            },

            {
              Header: "Created Date",
              Footer: "Created Date",
              accessor: "createdDate",
            },
           
            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",

              Cell: (cell) =>
                cell.row.original.userId ==
                  localStorage.getItem("UserId") &&
                JSON.parse(localStorage.getItem("Sidebaritems")).name ==
                  "ROLE_USER" ? (
                  <>
                    <div className="dropdown">
                      <button
                        className="btn color_1 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons opacity-10 size">person</i>
                        {/* <DeleteIcon /> */}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          onClick={() => {
                            // console.log(cell);
                          }}
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              rejectUserModal(cell);
                            }}
                          >
                            {/* reject User */}
                            <DeleteIcon />
                            Delete
                          </a>
                        </li>
                       
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              approveUserModal(cell);
                            }}
                          >
                            <EditIcon />
                            Edit Details
                          </a>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : 
                  JSON.parse(localStorage.getItem("Sidebaritems")).name ==
                    "ROLE_SUPER_ADMIN" ? (
                  <>
                    <div className="dropdown">
                      <button
                        className="btn color_1 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons opacity-10 size">person</i>
                        {/* <DeleteIcon /> */}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          onClick={() => {
                            // console.log(cell);
                          }}
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              rejectUserModal(cell);
                            }}
                          >
                            {/* reject User */}
                            <DeleteIcon />
                            Delete
                          </a>
                        </li>
                       
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              approveUserModal(cell);
                            }}
                          >
                            <EditIcon />
                            Edit Details
                          </a>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <>Not Allowed</>
                ),
              disableFilters: true,
            },
          ]
        : [
            {
              Header: "Id",
              Footer: "Id",
              accessor: "id", // accessor is the "key" in the data
            },

            {
              Header: "Mobile Number",
              Footer: "Mobile Number",
              accessor: "msisdn",
            },
            {
              Header: "Modified By",
              Footer: "Modified By",
              accessor: "modifiedBy", // accessor is the "key" in the data
            },

            {
              Header: "Modified Date",
              Footer: "Modified Date",
              accessor: "modifiedDateTime",
            },
            {
              Header: "Action",
              Footer: "Action",
              accessor: "action",
              Cell: (cell) => (
                <div className="dropdown">
                  <button
                    className="btn color_1 dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons opacity-10 size">person</i>
                    {/* <DeleteIcon /> */}
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li
                      onClick={() => {
                        // console.log(cell);
                      }}
                    >
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          rejectUserModal(cell);
                        }}
                      >
                        {/* reject User */}
                        <DeleteIcon />
                        Delete
                      </a>
                    </li>
                   
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          approveUserModal(cell);
                        }}
                      >
                        <EditIcon />
                        Edit Details
                      </a>
                    </li>
                  </ul>
                </div>
              ),

              disableFilters: true,
            },
          ],
    [modifiedState]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  useEffect(() => {
    if (formik.values.msisdn !== "") {
      SearchPost();
    }
  }, [TableStatus.pageSize, TableStatus.pageNo]);

  // useEffect(() => {
  //   if (selectedUserDetailApprove != undefined) {
  //     AccountId();
  //   }
  // }, [selectedUserDetailApprove]);


  useEffect(() => {
    if (selectedUserDetailApprove != undefined && JSON.parse(localStorage.getItem("Sidebaritems")).name ==
    "ROLE_SUPER_ADMIN") {
      AccountId();
    }
  }, [selectedUserDetailApprove]);

  useEffect(() => {
    formik.handleReset();
    seterror1(false);
    setData([]);

  }, [resetValue]);
  return (
    <>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>
      <div className="card-body">
        <form onSubmit={formik.handleSubmit} role="form" className="text-start">
          <div>
            <ThemeProvider theme={theme}>
              <div className="card shadow-none border bg_blue mt-4">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  Enter Mobile Number
                </span>

                <div className="card-body text-lg-start text-center">
                  <div className="row mt-4">
                    {/* <div className="col-md-1 pr-0 mt-2">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fw-bold"
                      >
                        Mobile Number:
                      </label>
                    </div> */}

                    <div className="col-md-4 col-lg-3 btn_wdt" id="inp_merge">
                      <div className="d-flex">
                      <input className="inpt_width"
  disabled
  value="+222"
/>
                      <TextField
                        autoComplete="on"
                        className="ms-0 w-100"
                        type="string"
                        label="Mobile Number"
                        name="msisdn"
                        variant="outlined"
                        size="small"
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip
                                title="Please enter a valid phone number"
                                placement="top"
                                arrow
                                sx={{ color: "#85CBF2" }}
                              >
                                <InfoIcon />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        // value={phoneNumber2}
                        // value=""
                        // onChange={(e) => handlechangenumber1(e)}

                        onChange={formik.handleChange}
                        value={formik.values.msisdn}
                        error={
                          formik.touched.msisdn && Boolean(formik.errors.msisdn)
                        }
                        helperText={
                          formik.touched.msisdn && formik.errors.msisdn
                        }
                        onInput={(e) => {
                          // e.target.value = Math.max(0, parseInt(e.target.value))
                          //   .toString()
                          //   .slice(0, 8);
                          e.target.value = e.target.value.slice(0, 8);
                        }}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;

                          if ((keyCode >= 48 && keyCode <= 57) || (keyCode == 13 )) {
                            seterror1(false);
                          } else {
                            event.preventDefault();
                            seterror1(true);
                          }
                        }}
                      />

                      
                    </div>

</div>

<div className="col-md-5 col-lg-4">
<button
                        type="submit"
                        className="btn pending_Up w_btn ms-3 btn_w8"
                        //  onClick={SearchPost}
                      >
                        Search
                        {/* <SearchRoundedIcon style={{ fontSize: "18px" }} /> */}
                      
                      </button>
                      <button
                        // onClick={formik.resetForm}
                        type="button"
                        className="btn resetBtn_UP ms-3 w_btn btn_w8 btnReset"
                        // onClick={Reset}
                        onClick={() => {
                          formik.resetForm();
                          seterror1(false);
                        }}
                      >
                        Reset
                        {/* <SettingsBackupRestoreRoundedIcon
                          style={{ fontSize: "17px" }}
                        /> */}
                   
                      </button>
</div>

                    <div className="row">
                      {error1 == true ? (
                        <>
                          <p style={{ color: "red" }}>
                            Only Numbers Are Allowed!!
                          </p>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ThemeProvider>
          </div>
        </form>
        {hide == true ? (
          <></>
        ) : (
          <>
            <form
              onSubmit={formik1.handleSubmit}
              role="form"
              className="text-start"
            >
              {data?.length > 0 ? (
                <>
                  <div>
                    <ThemeProvider theme={theme}>
                      <div className="card shadow-none border bg_blue mt-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                          Number List
                        </span>{" "}
                        <div className="card-body text-lg-start text-center">
                          {/* ............................Table Code.................. */}

                         
                          <div>
                            {selectedUserDetail != undefined && (
                              <div>
                                <button
                                  ref={modelButtonReject}
                                  type="button"
                                  className="btn btn-primary d-none"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop"
                                >
                                  Launch static backdrop modal
                                </button>

                                <div
                                  className="modal fade"
                                  id="staticBackdrop"
                                  data-bs-backdrop="static"
                                  data-bs-keyboard="false"
                                  tabindex="-1"
                                  aria-labelledby="staticBackdropLabel"
                                  aria-hidden="true"
                                >
                                  <div
                                    className="modal-dialog"
                                    style={{ width: "28%", maxWidth: "100%" }}
                                  >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5
                                          className="modal-title"
                                          id="staticBackdropLabel"
                                        >
                                           Are you sure you want to delete?
                                        </h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        ></button>
                                      </div>

                                      {/* <div className="modal-body">
                                    <TextField
                                      disabled
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="rules"
                                      variant="outlined"
                                      size="small"
                                      value={selectedUserDetail.msisdn}

                                    />
                                  </div> */}

                                      <div class="modal-body">
                                        <div class="row">
                                          <div className="col-md-8 mt_2">
                                            <div className="d-flex align-items-center">
                                              {/* <div class="col-6"> */}
                                              <label
                                                for="exampleInputEmail1"
                                                className="form-label text-nowrap m-0 me-2"
                                              >
                                                Mobile Number:
                                              </label>
                                              {/* </div> */}

                                              <input
                                                disabled
                                                className="form-control w-100"
                                                placeholder="Mobile Number"
                                                type="text"
                                                minLength="3"
                                                // value={selectedUserDetail?.dltId}
                                                value={
                                                  selectedUserDetail.msisdn
                                                }
                                              />
                                            </div>
                                          </div>

<div className="table-responsive mt-4">
                              <table className="table table-striped table-bordered dataTable table-sm">
                                <thead>
                                  <tr role="row">
                                    <th className="text-center width_2">
                                      UserName
                                    </th>
                                    {/* <th className="text-center width_2">
                                                        mobileNumber
                                                      </th> */}
                                  </tr>
                                </thead>
                                <tbody id="dropdown-item" role="rowgroup">
                                  {viewUsername?.map(
                                    (arg) => {
                                      return (
                                        <>
                                          <tr role="row">
                                            <td style={{fontSize: "13px"}}>
                                            {arg?.userName}
                                            </td>
                                            {/* <td>
                                                                {
                                                                  arg?.mobileNumber
                                                                }
                                                              </td> */}
                                          </tr>
                                        </>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            </div>

                                          {/* <div className="col-md-4">
                                            <Autocomplete
                                              aria-required
                                              // disabled={MenuItemPhoneBook==undefined}
                                              value={deleteIdChange}
                                              size="small"
                                              fullWidth
                                              defaultValue={byDeafultDeleteId}
                                              onChange={(e, val) => {
                                                setDeleteIdChange(val);
                                              }}
                                              multiple
                                              limitTags={2}
                                              id="multiple-limit-tags"
                                              options={byDeafultDeleteId}
                                              getOptionLabel={(option) =>
                                                option?.userName
                                              }
                                              // defaultValue={mappingArray}
                                              renderInput={(params) => (
                                                <TextField
                                                  size="small"
                                                  fullWidth
                                                  {...params}
                                                  label="User Name List"
                                                  // placeholder="User Name List"
                                                />
                                              )}
                                            />
                                          </div> */}
                                        </div>
                                      </div>
                                      <div className="modal-footer justify-content-between align-items-center">
                                        <button
                                          type="button"
                                          className="btn btn-secondary m-0"
                                          data-bs-dismiss="modal"
                                        >
                                          No
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          data-bs-dismiss="modal"
                                          onClick={() => {
                                            rejectUserApi(selectedUserDetail);
                                          }}
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {selectedUserDetailApprove != undefined && (
                              <div>
                                <button
                                  ref={modelButtonApprove}
                                  type="button"
                                  className="btn btn-primary d-none"
                                  data-bs-toggle="modal"
                                  data-bs-target="#staticBackdrop1"
                                >
                                  Launch static backdrop modal
                                </button>

                                <div
                                  className="modal fade"
                                  id="staticBackdrop1"
                                  data-bs-backdrop="static"
                                  data-bs-keyboard="false"
                                  tabindex="-1"
                                  aria-labelledby="staticBackdrop1Label"
                                  aria-hidden="true"
                                >
                                  <div
                                    className="modal-dialog modal-x"
                                    style={{ width: "44%", maxWidth: "100%" }}
                                  >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5
                                          className="modal-title"
                                          id="staticBackdrop1Label"
                                        >
                                          Update Details
                                        </h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={() => {
                                            setSelectedUserDetailApprove(
                                              undefined
                                            );
                                          }}
                                        ></button>
                                      </div>
                                      {/* <div className="modal-body">
                                    <TextField
                                      required={
                                        selectedUserDetailApprove != undefined
                                      }
                                      className="ms-4 w-50  "
                                      style={{
                                        borderRadius: "4px",
                                        marginTop: "10px",
                                      }}
                                      type="text"
                                      label="Mobile Number"
                                      name="msisdn1"
                                      variant="outlined"
                                      size="small"
                                      onChange={formik1.handleChange}
                                      value={formik1.values.msisdn1}
                                      error={
                                        formik1.touched.msisdn1 &&
                                        Boolean(formik1.errors.msisdn1)
                                      }
                                      helperText={
                                        formik1.touched.msisdn1 &&
                                        formik1.errors.msisdn1
                                      }
                                      
                                    />
                                  </div> */}
                                      <div className="modal-body">
                                        <div className="row">
                                          <div className="col-md-5" style={{marginTop:'-15px'}}>
                                            {/* <div class="col-3"> */}
                                            {/* <div className="d-flex align-items-cente"> */}
                                              <label
                                                for="exampleInputEmail1"
                                                className="form-label text-nowrap m-0 me-2"
                                              >
                                                Mobile Number:
                                              </label>
                                              {/* </div> */}
                                              <div className="row mx-0">
                                                                      <div className="col-3 d-flex flex-column px-0">
                                                <input className="inpt_width w-100 h-100" disabled value="+222" />
                                                </div>
                                                  <div className="col-9 px-0">
                                                  <input
                                                    type="number"
                                                    style={{fontSize:'1.2rem'}}
                                                    // title=""
                                                    // pattern="[6789][0-9]{9}"

                                                    // min="1000000000"
                                                    // min="4"
                                                    // max="10000000000"
                                                    required
                                                    value={phoneNumber1}
                                                    // value=""
                                                    onChange={(e) =>
                                                      handlechangenumber(e)
                                                    }
                                                    // value={selectedUserDetailApprove?.dltId}
                                                    className="form-control w-100 select_5 mobile_1"
                                                    id="exampleInputEmail1"
                                                    aria-describedby="emailHelp"
                                                  />
                                                  </div>                                                                                                                         
                                                </div>
                                                <div className="row justify-content-end mx-0">
                                                <div className="col-9 px-0">
                                                {error == true ? (
                                                  <>
                                                    <p
                                                      style={{
                                                        color: "red",
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                     "Minimum length of a mobile number is 8 digits"
                                                    </p>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                                </div>
                                              </div>
                                            {/* </div> */}
                                          </div>
                                          {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
                                          "ROLE_SUPER_ADMIN" ? (
                    <>
                  {/* {  alert("ll")} */}
                    {accountIdSkelton == true ? (
                                            <>
                                              <Box sx={{ width: 270 }}>
                                                <Skeleton />
                                                <Skeleton animation="wave" />
                                              </Box>
                                            </>
                                          ) : (
                                            <>
                                              <div className="col-md-7 user_name_list calendar_1">
                                                <Autocomplete
                                                  required
                                                  size="small"
                                                  fullWidth
                                                  value={userEditState}
                                                  onChange={(e, val) => {
                                                    setUserEditState(val);
                                                  }}
                                                  multiple
                                                  limitTags={2}
                                                  id="multiple-limit-tags"
                                                  options={accountidvalue}
                                                  isOptionEqualToValue={(option, value) =>
          option.userName === value.userName
        }
                                                  getOptionDisabled={(option) =>
          userEditState?.[0]
            ? userEditState?.[0]?.userName === "All"
              ? option.userName !== "All"
              : option.userName === "All"
            : null
        }
                                                  getOptionLabel={(option) =>
                                                    option?.userName
                                                  }
                                                  renderInput={(params) => (
                                                    <TextField
                                                      size="small"
                                                      fullWidth
                                                      {...params}
                                                      label="User Name List"
                                                    />
                                                  )}
                                                />
                                                {userEditState?.length == 0 && (
                                                  <>
                                                    <div>
                                                      <label
                                                        style={{ color: "red" }}
                                                      >
                                                        User name list is
                                                        mandatory Field
                                                        <span>*</span>
                                                      </label>
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                            </>
                                          )}


                                          <div className="modal-footer mt-3 justify-content-between align-items-center">
                                        <button
                                          type="button"
                                          className="btn btn-secondary m-0"
                                          data-bs-dismiss="modal"
                                          id="getcancel"
                                          onClick={() => {
                                            setSelectedUserDetailApprove(
                                              undefined
                                            );
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          disabled={userEditState?.length == 0}
                                          type="submit"
                                          className="btn btn-primary editcolor m-0"

                                          // onClick={changeModal}
                                          // data-bs-dismiss="modal"
                                        >
                                          Update
                                        </button>
                                      </div>
            
                  
                    </>
                  ) : (
                    <>
                    {/* {alert("kk")} */}
                    <div className="col-md-4 name_12" id="name_12">

                        <TextField
                          required
                          disabled
                          className="w-100"
                          label="Name"
                          // name="name"
                          variant="outlined"
                          size="small"
                          value={localStorage.getItem("usernamedisplayed")}
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Name"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                      <div className="modal-footer mt-3 justify-content-between align-items-center">
                                        <button
                                          type="button"
                                          className="btn btn-secondary m-0"
                                          data-bs-dismiss="modal"
                                          id="getcancel"
                                          onClick={() => {
                                            setSelectedUserDetailApprove(
                                              undefined
                                            );
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          // disabled={userEditState?.length == 0}
                                          type="submit"
                                          className="btn btn-primary editcolor m-0"

                                          // onClick={changeModal}
                                          // data-bs-dismiss="modal"
                                        >
                                          Update
                                        </button>
                                      </div>
                    
                    </>
                  )}
                                        </div>
                                      </div>
                                     
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="container-fluid px-0">
                              <div class="mb-3 mt-4">
                                <div class=" mt-2">
                                  <div>
                                    {selectedFlatRows.length > 0 && (
                                      <button onClick={deletUser}>
                                        Delete Users
                                      </button>
                                    )}
                                  </div>

                                  <table
                                    {...getTableProps()}
                                    id="example"
                                    className="table table-striped table-bordered dataTable table-sm"
                                    style={{ width: "100%" }}
                                  >
                                    <thead>
                                      {headerGroups.map((headerGroup) => (
                                        <tr
                                          {...headerGroup.getHeaderGroupProps()}
                                        >
                                          {headerGroup.headers.map((column) => (
                                            <th
                                              {...column.getHeaderProps(
                                                column.getSortByToggleProps()
                                              )}
                                              className="text-center width_2"
                                            >
                                              {column.render("Header")}
                                              <span>
                                                {column.isSorted
                                                  ? column.isSortedDesc
                                                    ? "↑"
                                                    : "↓"
                                                  : ""}
                                              </span>
                                            </th>
                                          ))}
                                        </tr>
                                      ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()}>
                                      {page.map((row) => {
                                        prepareRow(row);
                                        return (
                                          <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                              return (
                                                <td
                                                  {...cell.getCellProps()}
                                                  className="text-center"
                                                >
                                                  {cell.render("Cell")}
                                                </td>
                                              );
                                            })}
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                  {/* <div className="d-flex justify-content-between">
                                    <div>
                                      <span>
                                        Page:
                                        <strong>
                                          {data1?.pageable?.pageNumber + 1} of{" "}
                                          {data1?.totalPages}
                                        </strong>
                                      </span>
                                    </div>

                                    <div className="btn_n800">
                                      <button
                                        className="btn btn_primary "
                                        type="button"
                                        style={{ background: "#2C97D4" }}
                                        disabled={
                                          data1?.pageable?.pageNumber == 0
                                        }
                                        onClick={() => {
                                          setTableStatus({
                                            ...TableStatus,
                                            pageNo: TableStatus.pageNo - 1,
                                          });
                                        }}
                                      >
                                        Prev
                                      </button>

                                      <button
                                        className="btn btn_primary ms-2"
                                        type="button"
                                        style={{ background: "#2C97D4" }}
                                        disabled={
                                          data1?.totalPages ==
                                          data1?.pageable?.pageNumber + 1
                                        }
                                        onClick={() => {
                                          setTableStatus({
                                            ...TableStatus,
                                            pageNo: TableStatus.pageNo + 1,
                                          });
                                        }}
                                      >
                                        Next
                                      </button>
                              
                                    </div>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ThemeProvider>
                  </div>
                </>
              ) : (
                <></>
              )}
            </form>
          </>
        )}
      </div>
    </>
  );
};

export default NumberList;
